import {createReducer, on} from '@ngrx/store';

import {Substitute} from '../../shared/models/substitute.model';
import {deleteSubstitute, loadSubstitutes, loadSubstitutesFailure, loadSubstitutesSuccess, reloadSubstitutes} from './substitute.actions';

export const substituteFeatureKey = 'substitute';

export type SubstituteScope = 'my' | 'all';

export interface SubstituteState {
  data: Substitute[];
  loading: boolean;
  loaded: boolean;
  error: Error;
  scope: SubstituteScope;
}

export const substituteInitialState: SubstituteState = {
  data: [],
  loading: false,
  loaded: false,
  error: null,
  scope: 'my'
};

export const substituteReducer = createReducer(
  substituteInitialState,

  on(loadSubstitutes, (state, action) => ({
    ...state,
    data: null,
    loading: true,
    error: null,
    loaded: false,
    scope: action.scope
  })),
  on(reloadSubstitutes, state => ({...state, data: null, loading: true, error: null, loaded: false})),
  on(loadSubstitutesSuccess, (state, action) => ({
    ...state,
    data: action.data,
    loading: false,
    error: null,
    loaded: true
  })),
  on(loadSubstitutesFailure, (state, action) => ({
    ...state,
    data: null,
    loading: false,
    error: action.error,
    loaded: true
  })),
  on(deleteSubstitute, state => ({
    ...state,
    loading: true,
    loaded: true
  }))
);
